import {
  getAndSetCameras,
  getAndSetMicrophones,
  getAndSetSpeakers,
} from 'src/consumer/components/LiveSessionPage/LiveSessionPageComponents'

export const checkAvailableDevices = async (
  setMicrophoneError,
  setCameraError,
  setAvailableCameras,
  setAvailableMicrophones,
  setAvailableSpeakers,
  setSelectedCamera,
  setSelectedMicrophone,
  setSelectedSpeaker,
  setGiveBothPermissionsDialogOpen,
) => {
  try {
    const permissionToAccessMicrophone = await navigator.permissions.query({ name: 'microphone' })
    const permissionToAccessCamera = await navigator.permissions.query({ name: 'camera' })

    if (
      permissionToAccessMicrophone.state === 'granted' &&
      permissionToAccessCamera.state === 'granted'
    ) {
      setMicrophoneError(false)
      getAndSetMicrophones({ setAvailableMicrophones, setSelectedMicrophone })
      getAndSetSpeakers({ setAvailableSpeakers, setSelectedSpeaker })

      setCameraError(false)
      getAndSetCameras({ setAvailableCameras, setSelectedCamera })
    } else if (
      permissionToAccessMicrophone.state === 'prompt' &&
      permissionToAccessCamera.state === 'prompt'
    ) {
      setGiveBothPermissionsDialogOpen(true)
    } else {
      if (permissionToAccessMicrophone.state === 'granted') {
        setMicrophoneError(false)
        getAndSetMicrophones({ setAvailableMicrophones, setSelectedMicrophone })
        getAndSetSpeakers({ setAvailableSpeakers, setSelectedSpeaker })
      } else {
        setMicrophoneError(true)
      }

      if (permissionToAccessCamera.state === 'granted') {
        setCameraError(false)
        getAndSetCameras({ setAvailableCameras, setSelectedCamera })
      } else {
        setCameraError(true)
      }
    }
  } catch (e) {
    console.log(e)
    console.log('Firefox or Safari, handling of permissions in catch statement')

    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then(() => {
        setMicrophoneError(false)
        getAndSetMicrophones({ setAvailableMicrophones, setSelectedMicrophone })
        getAndSetSpeakers({ setAvailableSpeakers, setSelectedSpeaker })

        setCameraError(false)
        getAndSetCameras({ setAvailableCameras, setSelectedCamera })
      })
      .catch(() => {
        setMicrophoneError(true)
        setCameraError(true)
      })
  }
}
